// extracted by mini-css-extract-plugin
export default {"Dropdown-menu":"TagName_Dropdown-menu__EX8Pb","container":"TagName_container__qcb7p","inputDefault":"TagName_inputDefault__pQUQl","dark":"TagName_dark__85Yi2"};